export default Object.freeze({
    ACCEPTED: 'accepted',
    PENDING: 'pending',
    REFUSED: 'refused',
    ACCEPTEDNOTCONFORMED: 'acceptednotconformed',
});
